module.exports = __webpack_public_path__ + "static/scanObject-f9d9f296a8b436f6f4365188c6ba9b1c.jpg";